export var CallActionType;
(function (CallActionType) {
    CallActionType[CallActionType["ROUTE_TO_QUEUE"] = 0] = "ROUTE_TO_QUEUE";
    CallActionType[CallActionType["HANGUP"] = 1] = "HANGUP";
    CallActionType[CallActionType["ROUTE_TO_IVR"] = 2] = "ROUTE_TO_IVR";
    CallActionType[CallActionType["USER_INPUT"] = 3] = "USER_INPUT";
    CallActionType[CallActionType["FORWARD_TO_PHONE_NUMBER"] = 4] = "FORWARD_TO_PHONE_NUMBER";
    CallActionType[CallActionType["NUMBER_INPUT_WEBHOOK"] = 5] = "NUMBER_INPUT_WEBHOOK";
    CallActionType[CallActionType["ROUTE_TO_VOICEMAIL"] = 6] = "ROUTE_TO_VOICEMAIL";
    CallActionType[CallActionType["SEND_TO_EXTERNAL_SERVICE"] = 7] = "SEND_TO_EXTERNAL_SERVICE";
})(CallActionType || (CallActionType = {}));
//# sourceMappingURL=call-action.js.map